import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Record } from 'immutable';
import Col from 'react-bootstrap/lib/Col';

import config from '../../config';
import { translate as t } from '../../lib/I18n';

import ValidatedField from '../form/ValidatedField';


function CustomerName ({ form, validation, visited, onChange, vertical, disabled, userTitle, ...props }) {
    const isTitleInvalid = (title) => _.isString(title) && !config.get('customerTitles').includes(title);
    const hasInvalidTitle = isTitleInvalid(userTitle) || isTitleInvalid(form.title);
    const disableTitle = disabled && !hasInvalidTitle;
    return (
        <div>
            <Col md={ vertical ? 6 : 2 } className={ vertical ? 'col-md-offset-right-6' : '' }>
                <ValidatedField type="select"
                                form={ form }
                                validation={ validation }
                                onChange={ onChange }
                                id="title"
                                field="title"
                                outsideLabel={false}
                                label={ t('customerdetails.title') }
                                placeholder={ t('customerdetails.title') }
                                labelClassName="sr-only"
                                groupClassName="select-container"
                                visited={ visited }
                                disabled={ disableTitle }
                                required
                                {...props}>
                    { hasInvalidTitle && <option disabled key="invalid-title">{ userTitle }</option> }
                    { config.get('customerTitles').map((title, i) => <option key={ i }>{ title }</option>) }
                </ValidatedField>
            </Col>
            <Col md={ vertical ? 6 : 5 }>
                <ValidatedField type="text"
                                form={ form }
                                validation={ validation }
                                onChange={ onChange }
                                id="firstName"
                                field="firstNames"
                                placeholder={ t('customerdetails.name') }
                                label={ t('customerdetails.name') }
                                labelClassName="sr-only"
                                visited={ visited }
                                disabled={ disabled }
                                required
                                {...props} />
            </Col>
            <Col md={ vertical ? 6 : 5 }>
                <ValidatedField type="text"
                                form={ form }
                                validation={ validation }
                                onChange={ onChange }
                                id="surname"
                                field="surname"
                                placeholder={ t('customerdetails.surname') }
                                label={ t('customerdetails.surname') }
                                labelClassName="sr-only"
                                visited={ visited }
                                disabled={ disabled }
                                required
                                {...props} />
            </Col>
        </div>
    );
}


CustomerName.propTypes = {
    form: PropTypes.instanceOf(Record).isRequired,
    onChange: PropTypes.func.isRequired,
    validation: PropTypes.object,
    visited: PropTypes.bool,
    vertical: PropTypes.bool,
    disabled: PropTypes.bool,
    userTitle: PropTypes.string
};

CustomerName.defaultProps = {
    validation: null,
    visited: false,
    vertical: false,
    disabled: false,
    userTitle: null
};


export default CustomerName;



// WEBPACK FOOTER //
// ./src/components/customer/Name.js